import type { Incident } from '../../services/incidentsApi';

export function clipFilenameLooksLikeReviewRing(filename?: string | null): boolean {
  return /review[_-]?ring/i.test(String(filename || '').trim());
}

export type EvidenceDeliveryRow = {
  label: string;
  value: string;
  tone?: 'ok' | 'warn' | 'muted' | 'error';
};

export function buildEvidenceDeliveryRows(args: {
  incident: Incident | null | undefined;
  hasCloudSnapshot: boolean;
  hasCloudClip: boolean;
  clipFilename?: string | null;
  clipOnEdge?: boolean;
  clipPromotionState?: string;
  snapshotPendingUpload?: boolean;
}): EvidenceDeliveryRow[] {
  void args.incident;
  const rows: EvidenceDeliveryRow[] = [];

  rows.push({
    label: 'Detection / observation',
    value: 'Raised on edge — cloud row is metadata + proof delivery status',
    tone: 'muted',
  });

  rows.push({
    label: 'Snapshot (cloud)',
    value: args.hasCloudSnapshot
      ? 'Uploaded — still image should appear below'
      : 'Not in cloud yet — use Request snapshot upload if edge captured one',
    tone: args.hasCloudSnapshot ? 'ok' : 'warn',
  });

  const reviewRing = clipFilenameLooksLikeReviewRing(args.clipFilename);
  if (args.hasCloudClip) {
    rows.push({
      label: 'Clip (cloud)',
      value: reviewRing
        ? 'Uploaded review-ring segment — may not be the tight evidence-centered clip'
        : 'Uploaded — use timing below to confirm it covers the observed condition',
      tone: reviewRing ? 'warn' : 'ok',
    });
  } else if (args.clipOnEdge) {
    const promo = String(args.clipPromotionState || '').toUpperCase();
    rows.push({
      label: 'Clip',
      value:
        promo === 'PROMOTING'
          ? 'On edge — promotion upload in progress'
          : 'On edge only — open this review item to request one cloud upload',
      tone: promo === 'PROMOTING' ? 'warn' : 'warn',
    });
  } else {
    rows.push({
      label: 'Clip (cloud)',
      value: 'Not in cloud (clips are often kept on edge to reduce pipeline load)',
      tone: 'muted',
    });
  }

  return rows;
}
